export class SMSRouteDefs {
  public static FEATURE_PATH = "sms";
}
